module.exports = __webpack_public_path__ + "img/shield_with_gradient.d2be7828.svg";